import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import SportCreateEditForm from './Components/SportCreateEditForm';
import SportApi from './SportApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: SportCreateEditForm,
                getCreate: SportApi.create,
                defaults: {},
                successMessage: "Sport Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}